import { render, staticRenderFns } from "./PersonnelCostApplication.vue?vue&type=template&id=1bf33fbb&scoped=true"
import script from "./PersonnelCostApplication.vue?vue&type=script&lang=js"
export * from "./PersonnelCostApplication.vue?vue&type=script&lang=js"
import style0 from "./PersonnelCostApplication.vue?vue&type=style&index=0&id=1bf33fbb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf33fbb",
  null
  
)

export default component.exports